import {VehicleFinancingDownPayment} from '@dms/api/sales';

/** Down payment axis of every rate matrix, in percent. */
export const RATE_MATRIX_DOWN_PAYMENTS: VehicleFinancingDownPayment[] = [
  0, 10, 20, 30, 40, 50, 60, 70, 80, 90,
];
